import React from "react";



export default function HtmlEmbed(props) {
    const { html, wrapperTag, style } = props.componentConfig;

    const WrapperTag = wrapperTag || "div";

    return (
        <WrapperTag
            style={{
                width: "100%",
                ...style,
            }}
            dangerouslySetInnerHTML={{ __html: html || "" }}
        />
    );
}

HtmlEmbed.displayName = "HtmlEmbed";

export const componentDescription = {
    componentConfig: {
        html: {
            label: "HTML embebido",
            errorMessage: "",
            fieldName: "html",
            type: "textarea",
            defaultValue: "",
            required: true,
            regex: "",
            textSize: "h6",
        },
        wrapperTag: {
            label: "Etiqueta contenedora (div, section, article...)",
            errorMessage: "",
            fieldName: "wrapperTag",
            type: "text",
            defaultValue: "div",
            required: false,
            regex: "",
            textSize: "h6",
            traducible: false,
        },
    },
};